import { style, transition } from '@angular/animations';
import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { Subject } from "rxjs/Subject";
import { CanonicalService } from "../shared/canonical.service";

@Component({
  selector: "app-fcm",
  templateUrl: "./fcm.component.html",
  styleUrls: ["./fcm.component.scss"],
})
export class fcmComponent implements OnInit, AfterViewInit, OnDestroy {
  private unSubscribe = new Subject<boolean>();
  @ViewChild("downContent", { static: false })
  downContent: ElementRef<HTMLDivElement>;
  activeIndex = 0;
  intervalId: any;

  constructor(private canonicalService: CanonicalService) {}

  ngOnInit() {
    this.canonicalService.createLinkForCanonicalURL();
    this.startAutoScroll();
  }

  ngAfterViewInit() {
    this.setupHoverEvents();
    this.setupClickEvents();
    const header = document.querySelector('app-navbar > header');
      if (header) {
        header.classList.add('home');
      }


      function reveal() {
        const reveals = document.querySelectorAll('.reveal');
        for (let i = 0; i < reveals.length; i++) {
          const windowHeight = window.innerHeight;
          const revealTop = reveals[i].getBoundingClientRect().top;
          const revealPoint = windowHeight - 150;

          if (revealTop < revealPoint) {
            reveals[i].classList.add('active');
          } else {
            reveals[i].classList.remove('active');
          }
        }
      }

      window.addEventListener('scroll', reveal);

      function enterFromRight() {
        const enterFromRights = document.querySelectorAll('.enter-from-right');
        for (let i = 0; i < enterFromRights.length; i++) {
          const windowHeight = window.innerHeight;
          const enterFromRightTop = enterFromRights[i].getBoundingClientRect().top;
          const enterFromRightPoint = windowHeight - 150;

          if (enterFromRightTop < enterFromRightPoint) {
            enterFromRights[i].classList.add('active');
          } else {
            enterFromRights[i].classList.remove('active');
          }
        }
      }

      window.addEventListener('scroll', enterFromRight);

      function slideIn() {
        const slideIns = document.querySelectorAll('.slide-in');
        for (let i = 0; i < slideIns.length; i++) {
          const windowHeight = window.innerHeight;
          const slideInTop = slideIns[i].getBoundingClientRect().top;
          const slideInPoint = windowHeight - 150;
          if (slideInTop < slideInPoint) {
            slideIns[i].classList.add('active');
          } else {
            slideIns[i].classList.remove('active');
          }
        }
      }

      window.addEventListener('scroll', slideIn);
      slideIn();
  }

  scrollToContent() {
    this.downContent.nativeElement.scrollIntoView({ behavior: "smooth" });
  }

  ngOnDestroy() {
    this.clearIntervals();
  }

  startAutoScroll() {
    this.intervalId = setInterval(() => {
      this.moveToNextContent();
    }, 2000);
  }

  moveToNextContent() {
    this.activeIndex = (this.activeIndex + 1) % 6;
    this.updateActiveContent();
  }

  stopAutoScroll() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
  navigateTo(index: number) {
    this.stopAutoScroll();
    this.activeIndex = index;
    this.updateActiveContent();
  }

  setupHoverEvents() {
    const buttons = document.querySelectorAll(".fcmch1");
    const contents = document.querySelectorAll(".homecontent");

    buttons.forEach((button) => {
      button.addEventListener("mouseenter", () => this.stopAutoScroll());
      button.addEventListener("mouseleave", () => this.startAutoScroll());
    });

    contents.forEach((content) => {
      content.addEventListener("mouseenter", () => this.stopAutoScroll());
      content.addEventListener("mouseleave", () => this.startAutoScroll());
    });
  }

  setupClickEvents() {
    const buttons = document.querySelectorAll(".fcmch1");

    buttons.forEach((button, index) => {
      button.addEventListener("click", () => {
        this.stopAutoScroll();
        this.activeIndex = index;
        this.updateActiveContent();
      });
    });
  }

  clearIntervals() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  updateActiveContent() {
    const buttons = document.querySelectorAll(".fcmch1");
    const slides = document.querySelectorAll(".homecontent");

    buttons.forEach((button, index) => {
      button.classList.toggle("active", index === this.activeIndex);
    });

    slides.forEach((slide, index) => {
      slide.classList.toggle("active", index === this.activeIndex);
    });
  }

}
